import {SessionService} from './session';
import {MapService} from './map';
import {BackendModule} from '../modules/backend.module';
import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';

//this service will load classes list. Reservations service will make and cancel reservations
@Injectable()
export class BeautyClassesService {
  allClasses: any = [];
  categories: any = null;

  constructor(public backendModule: BackendModule,
              public mapService: MapService,
              public sessionService: SessionService) {
  }

  loadNext = (date: number,
              firstLoad?: boolean,
              fromTime?: number,
              toTime?: number,
              latitude?: string,
              longitude?: string,
              radius?: string,
              services?: number[],
              gym?: number[],
              city?: number,
              zones?: string[],
              categories?: number[]
  ) => {
    if (firstLoad) {
      this.allClasses[date].loading = true;
    }

    let start = new Date();
    let end = new Date();
    start.setDate(start.getDate() + date)
    end.setDate(end.getDate() + date)
    end.setHours(23, 59, 59)
    if (date !== 0) {
      if (fromTime) {
        start.setHours(fromTime, 0, 0, 0)
      } else start.setHours(0, 0, 0, 0)
      if (toTime) {
        end.setHours(toTime, 0, 0, 0)
      }
    } else {
      let now = new Date();
      start.setHours(fromTime, 0, 0, 0)
      if (start < now) {
        start = now;
        if (toTime) {
          end.setHours(toTime, 0, 0, 0)
        }
      }
    }
    return new Promise((resolve, reject) => {
      if (firstLoad) {
        this.allClasses[date].page = 1;
      }
      let params = new HttpParams();
      params = params.append('from_date', start.toJSON());
      params = params.append('to_date', end.toJSON());
      params = params.append('latitude', latitude ? latitude : this.mapService.myLocation.lat.toString());
      params = params.append('longitude', longitude ? longitude : this.mapService.myLocation.lng.toString());
      params = params.append('pagination[page]', this.allClasses[date].page.toString());
      params = params.append('pagination[count]', '30');
      if (radius) {
        params = params.append('radius', radius);
      }
      if (gym) {
        params = params.append('gym_id', gym.toString())
      }
      if (city) {
        params = params.append('city_id[]', city.toString())
      }
      if (zones) {
        zones.forEach(zone => {
          params = params.append('zone_id[]', zone.toString())
        });
      }
      if (services) {
        services.forEach(service => {
          params = params.append('services[]', service.toString());
        });
      }

      if (this.categories != null) {
        if (categories && categories.length !== this.categories.length) {
          categories.forEach(category => {
            params = params.append('activities[]', category.toString());
          });
        }
      }

      params = params.append('product', 'beauty');

      this.backendModule.getAPI('lesson_list', {
        observe: 'response',
        params: params
      })
        .subscribe((data: any) => {
          if (firstLoad) {
            this.allClasses[date].loading = false;
            this.allClasses[date].classes = this.allClasses[date].classes = data.body.data;
          } else if (
            data.body.data.length >= 1 &&
            this.allClasses[date].classes[0].schedule.id !== data.body.data[0].schedule.id
          ) {
            //This if is to avoid the IOS repetition when refreshing
            this.allClasses[date].classes = this.allClasses[date].classes.concat(data.body.data)
          }
          this.allClasses[date].page++
          this.allClasses[date].classes.forEach(lesson => {
            lesson.distance = this.mapService.getDistance(lesson.gym.latitude, lesson.gym.longitude)
            lesson.schedule.lessonEndTime = new Date()
            lesson.schedule.lessonEndTime.setTime(
              new Date(
                lesson.schedule.lesson_time).getTime() + (lesson.schedule.length * 60 * 1000
              )
            );
          });
          resolve(),
            (err) => {
              this.sessionService.reportError(
                'classesService',
                'loadNext()',
                err
              );
              this.allClasses[date].loading = false;
            }
        });
    });
  }

  loadAll(
    firstLoad?: boolean,
    fromTime?: number,
    toTime?: number,
    latitude?: string,
    longitude?: string,
    radius?: string,
    services?: number[],
    gym?: number[],
    city?: number,
    zones?: string[],
    categories?: number[]
  ) {
    for (var i = 0; i <= 14; i++) {
      this.loadNext(
        i,
        firstLoad ? firstLoad : null,
        fromTime ? fromTime : null,
        toTime ? toTime : null,
        latitude ? latitude : null,
        longitude ? longitude : null,
        radius ? radius : null,
        services ? services : null,
        gym ? gym : null,
        city ? city : null,
        zones ? zones : null,
        categories ? categories : null
      );
    }
  }

  initiateClasses() {
    for (var i = 0; i <= 14; i++) {
      this.allClasses[i] =
        {
          classes: [],
          page: 1,
          loading: false,
        }
    }
  }

  loadCategories() {
    this.backendModule.getAPI(`activities?product=all`).subscribe(
      (data: any) => {
        const categories = data.filter((category) => category.type === 'Activities::Beauty');
        this.categories = this.sortCategories(categories)
      },
      err => {
        this.categories = [];
        this.sessionService.reportError(
          'classesService',
          'loadCategories()',
          err
        );
      }
    )
  }

  sortCategories(data) {
    data.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    })

    return data;
  }
}



// WEBPACK FOOTER //
// ./src/services/beauty-classes.ts